import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-blank-space',
  templateUrl: './blank-space.component.html',
  styleUrls: ['./blank-space.component.scss']
})
export class BlankSpaceComponent implements OnInit {
  @Input() value: string;

  constructor() {}

  ngOnInit() {}

  onDragStart(event: DragEvent) {
    event.dataTransfer.setData('text/plain', 'blank-space');
  }

  

}
